import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { ActionType, TableColumn } from "../../../../Component/Model/Table/Table";
import { ActionsCell } from "../../../../Component/Common/Components/DataTable/ActionsCell";
import { DateFormatter } from "../../../../Component/Model/helpers";
import { ReportGeneration } from "../../../../Component/Model/Dto/EmploymentEquity/Reporting";

interface ReportRow {
    reportType: string;
    reportName: string;
    reportAsAt: string;
    actions: ActionType[];
}

interface ReportTable {
    columns: Array<TableColumn>;
    rows: Array<ReportRow>;
}

function getActionColumns(item: ReportGeneration.ReportGenerationResult, downloadCertificate: (documentId: number) => void): ActionType[] {
    const actions: ActionType[] = [];
    if (item.documentId) {
        actions.push(
            // Future icon for viewing without downloading
            // {
            //     key: item.toString(),
            //     label: 'View Certificate',
            //     action: () => { },
            //     icon: {
            //         color: 'secondary',
            //         name: 'visibility'
            //     }
            // },
            {
                key: item.toString(),
                label: 'Download Report',
                action: () => {
                    downloadCertificate(item.documentId!);
                },
                icon: {
                    color: 'secondary',
                    name: 'file_download'
                }
            }
        )
    }
    return actions;
}

export function ReportsTableMapper(results: ReportGeneration.ReportGenerationResult[], downloadReport: (documentId: number) => void): ReportTable {
    const columns = [
        { Header: 'Report Type', accessor: 'reportType', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Report Name', accessor: 'reportName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Report As At', accessor: 'reportAsAt', id: "reportAsAt", Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true, }
    ];

    if (results.length >= 0) {
        const rows: ReportRow[] = results.map((item: ReportGeneration.ReportGenerationResult) => (
            {
                reportType: item.reportType,
                reportName: item.reportName,
                reportAsAt: DateFormatter(item.reportingStartDate.toString()),
                actions: getActionColumns(item, downloadReport)
            }));
        return { columns: columns, rows: rows };
    } else {
        return { columns: columns, rows: [] };
    }
}